import { IDotDangKyNganh2ActionTypes } from "../../action-types/quan-ly-nganh-2/IDotDangKyNganh2Actions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDotDangKyNganh2Reducer } from "../../reducer-model/quan-ly-nganh-2/IDotDangKyNganh2Reducer";

const iniState: IDotDangKyNganh2Reducer = {
    status: eReducerStatusBase.is_not_initialization,
    dotDangKyNganh2s: [],
    dotDangKyNganh2Editing: undefined,
    isShowEditModal: false
};

export const dotDangKyNganh2Reducer = (state : IDotDangKyNganh2Reducer = iniState, action: IDotDangKyNganh2ActionTypes): IDotDangKyNganh2Reducer => {
    switch (action.type) {
        case "DOT_DANG_KY_NGANH_2_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "DOT_DANG_KY_NGANH_2_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                dotDangKyNganh2s: action.payload
            };
        case "DOT_DANG_KY_NGANH_2_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                dotDangKyNganh2s: []
            };
        case "DOT_DANG_KY_NGANH_2_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                dotDangKyNganh2Editing: action.payload,
            };
        case "DOT_DANG_KY_NGANH_2_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
                dotDangKyNganh2Editing: undefined,
            };
        case "DOT_DANG_KY_NGANH_2_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "DOT_DANG_KY_NGANH_2_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                dotDangKyNganh2Editing: undefined,
                isShowEditModal: false
            };
        case "DOT_DANG_KY_NGANH_2_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DOT_DANG_KY_NGANH_2_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            };
        case "DOT_DANG_KY_NGANH_2_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DOT_DANG_KY_NGANH_2_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        
        default:
            return state;
    }
}